import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ErrorItem from './error-item';

export default class ErrorList extends React.Component {
  constructor(props) {
    super(props);

    // Bind methods
    this.clickCloseErrorHandler = this.clickCloseErrorHandler.bind(this);
    this.renderErrorItem = this.renderErrorItem.bind(this);

    this.state = {
      errors: props.errors,
    };
  }

  /* life cycle */

  componentWillReceiveProps(newProps) {
    const { errors } = newProps;
    this.setState({
      errors,
    });
  }

  /* event handlers */

  closeError(errorItem) {
    const item = errorItem;
    const { errors } = this.state;
    if (!errors) {
      return;
    }
    const index = errors.indexOf(item, 0);
    if (index >= 0) {
      errors.splice(index, 1);
      this.setState({ errors });
    }
  }

  clickCloseErrorHandler(errorItem) {
    this.closeError(errorItem);
  }

  /* render */

  renderErrorItem(error) {
    if (!error) {
      return null;
    }
    const { message, name } = error;

    return (
      <ErrorItem
        key={name}
        message={message}
        data={error}
        onClickClose={this.clickCloseErrorHandler}
      />
    );
  }

  render() {
    const { errors } = this.state;
    const items = errors ? errors.map(this.renderErrorItem) : null;

    return (
      <div className="configurator__ui-container--top-center configurator__ui-error-container">
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          {items}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

ErrorList.propTypes = {
  errors: PropTypes.array,
};



// WEBPACK FOOTER //
// ./js/components/configuration/error-list/error-list.jsx